// --------------- pdp media mobile view

if (window.matchMedia) {
  const mq = window.matchMedia("(min-width: 750px)");
  mq.addListener(handleWidthChange);
  handleWidthChange(mq);
}

function handleWidthChange(mq) {
  const sliderEl_div = document.querySelector('[data-main-pdp-swiper]');
  if (!sliderEl_div) return; // exit if no slider on this page

  const sliderEl = document.querySelector('[data-pdp-main-slider]');
  if (!sliderEl) return;

  const optionsAttr = sliderEl.getAttribute('data-slider-options');

  if (mq.matches) {
    // Desktop: destroy swiper if exists
    if (sliderEl_div.swiper) {
      sliderEl_div.swiper.destroy(true, true);
    }
  } else {
    // Mobile: initialize swiper if not already initialized
    if (!sliderEl_div.swiper) {
      if (optionsAttr) {
        const options = JSON.parse(optionsAttr);
        new Swiper(sliderEl_div, options);
      }
    }
  }
}




document.addEventListener('click', function(e) {
  if (e.target.classList.contains('size_text')) {
    const popup = document.querySelector('.size-popup');


    if (popup) {
      popup.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    }
  }
});



const closeButtons_size = document.querySelectorAll('.size-popup-close');

if (closeButtons_size.length > 0) {
  closeButtons_size.forEach(function(button) {
    button.addEventListener('click', function() {
      const popup_size = document.querySelector('.size-popup');

      if (popup_size) {
        popup_size.style.display = 'none';
      }

      document.body.classList.remove('overflow-hidden');
    });
  });
}

function custom_addtocart(product,open_drawer,existingFeeItem,updatedPrice){
  console.log("In function",product)
  fetch(`${routes.cart_add_url}`,{
          method: 'POST',
          headers: { "Accept": "application/json", "Content-Type": "application/json" },
          body: JSON.stringify(product)
    })
    .then(response => response.json())
    .then(response => {           
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally((e) => {
      
      if (existingFeeItem) {
       fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const index = cart.items.findIndex(item => item.id == '52763555725641');
        let existingFeeItem = cart.items.find(item => item.id == '52763555725641');
        custom_changecart(index,updatedPrice,existingFeeItem,true)
        });
      }
      if(open_drawer){
        const this_cartDrawer = document.querySelector('cart-drawer');
        this_cartDrawer.refresh(true);
      }
    });
}
function custom_updatecart(updates,open_drawer){
  fetch(`${routes.cart_update_url}`,{
    method: 'POST',
    headers: { "Accept": "application/json", "Content-Type": "application/json" },
    body:  JSON.stringify({ updates }),
  })
  .then(response => response.json())
  .then(response => {
    // console.log( response.item_count);
      if(open_drawer){
      const this_cartDrawer = document.querySelector('cart-drawer');
      this_cartDrawer.refresh(true, response.item_count);
    }   
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally((e) => {  
  });
}

function custom_changecart(lineItem,open_drawer,updates){
  var line = line + 1;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line: line, // Line item index (1-based)
      quantity: 0, // Line item index (1-based)
    
    })
  })
  .then(res => res.json())
  .then(cart => {
    console.log('Cart updated:', cart);
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  })
  .finally((e) => {
    if (updates) {
      custom_updatecart(updates,true)
    }
  });
}




/****** Newsletter popup start ******/
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("newsletter-popup-form");
  if (!popup) return;

  const formBlock = popup.querySelector(".newsletter-form-block");

  if (!localStorage.getItem("newsletter_shown")) {
    setTimeout(function () {
      popup.style.display = "block";
      document.body.classList.add("newsletter-popup-open");

      localStorage.setItem("newsletter_shown", "true");
    }, 25000); // 10 seconds
  }

  document.addEventListener("click", function (event) {
    const closeBtn = event.target.closest(".close-newsletter-form");

    if (closeBtn) {
      popup.style.display = "none";
      document.body.classList.remove("newsletter-popup-open");
    }
  });
});



/****** Newsletter popup end ******/

//cart upcell product swiper
(function () {
  function initUpsellSliders(root) {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library is not loaded.');
      return;
    }
    const scope = root || document;
    scope.querySelectorAll('.cartdrawer-upsell').forEach(function (container) {
      const slider = container.querySelector('.cartdrawer-upsell-wrap');
      if (!slider) return;
      const prevButton = container.querySelector('.upsell-slider-prev');
      const nextButton = container.querySelector('.upsell-slider-next');
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }
      const sliderOptions = container.getAttribute('data-slider-options');
      let options = {};
      if (sliderOptions) {
        try {
          options = JSON.parse(sliderOptions);
        } catch (error) {
          console.error(
            'Upsell slider options JSON error:',
            error,
            sliderOptions
          );

          return;
        }
      }
      if (prevButton && nextButton) {
        options.navigation = {
          prevEl: prevButton,
          nextEl: nextButton
        };
      }
      options.slidesPerView = 1;
      options.slidesPerGroup = 1;
      options.loop = false;

      options.observer = true;
      options.observeParents = true;
      options.observeSlideChildren = true;

      new Swiper(slider, options);

      const slideCount = slider.querySelectorAll('.swiper-slide').length;

      if (slideCount <= 1) {
        if (prevButton) {
          prevButton.style.display = 'none';
        }

        if (nextButton) {
          nextButton.style.display = 'none';
        }
      } else {
        if (prevButton) {
          prevButton.style.display = '';
        }

        if (nextButton) {
          nextButton.style.display = '';
        }
      }
    });
  }

  function runUpsellInit() {
    setTimeout(function () {
      initUpsellSliders(document);
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', runUpsellInit);

  document.addEventListener('shopify:section:load', function (event) {
    initUpsellSliders(event.target);
  });

  const observer = new MutationObserver(function (mutations) {
    let shouldInit = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (
          node.matches?.('.cartdrawer-upsell') ||
          node.querySelector?.('.cartdrawer-upsell')
        ) {
          shouldInit = true;
        }
      });
    });

    if (shouldInit) {
      setTimeout(function () {
        initUpsellSliders(document);
      }, 100);
    }
  });

  function startUpsellObserver() {
    const cartDrawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer');

    if (!cartDrawer) return;

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    startUpsellObserver();
  });

})();